import { ListItemIcon, ListItemText, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import type { TranslationKey } from "../../../../../localization/translations"

export type OverflowMenuEntry = Readonly<{
    labelId: TranslationKey
    label: string
    icon: IconDefinition
    onClick: () => void
}>

const useStyles = makeStyles()((theme) => ({
    icon: {
        minWidth: "1.75rem",
        color: theme.palette.tailwind.gray[500],
    },
}))

type Props = Readonly<{
    entry: OverflowMenuEntry
    onClick: () => void
}>

/** One icon-and-label row of the week menu's dropdown menus. */
export function OverflowMenuItem({ entry, onClick }: Props) {
    const { classes } = useStyles()

    return (
        <MenuItem dense onClick={onClick}>
            <ListItemIcon className={classes.icon}>
                <FontAwesomeIcon icon={entry.icon} />
            </ListItemIcon>
            <LocalizedStrict id={entry.labelId}>
                <ListItemText>{entry.label}</ListItemText>
            </LocalizedStrict>
        </MenuItem>
    )
}
